import { render, staticRenderFns } from "./ServiceChangeReview.vue?vue&type=template&id=540abacf&scoped=true"
import script from "./ServiceChangeReview.vue?vue&type=script&lang=js"
export * from "./ServiceChangeReview.vue?vue&type=script&lang=js"
import style0 from "./ServiceChangeReview.vue?vue&type=style&index=0&id=540abacf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540abacf",
  null
  
)

export default component.exports